import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import { IDatasourceRevision } from '~src/revisionHistoryDatasource/serverApi/types/IDatasourceRevision';


export namespace RevisionActionDatasource {
  export function  getDatasourceRevisionActionButtons(): RevisionHistoryActionButton<IDatasourceRevision>[] {
    return [
      deleteDataSourceRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }

  // action button factories
  function deleteDataSourceRevisionAction(): RevisionHistoryActionButton<IDatasourceRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IDatasourceRevision>) => {
        DeleteRevisionAction.showDeleteDataSourceRevisionDialog(context.selectedItem, context);
      }
    };
  }
}
